import { QuoteEdit,QuoteRecordEdit,QuoteDel,QuoteAdd,MultiplequoteEdit,UploadQuoteattachment,QuoteattachmentDel,QuoteCopy } from "@a/quote.js";
import Cookies from "js-cookie"
//cookies
import { setToken, setUsername, getUsername, getToken, removeToken, removeUsername } from "../../utils/cookies";
const state ={
    token: "" || getToken(),
    username: "" || getUsername(),
}
const getters ={}
const mutations ={
    SET_TOKEN(state, value){ // 设置 token
        state.token = value;
        value && setToken(value);
    },
    SET_USERNAME(state, value){ // 设置用户名
        state.username = value;
        value && setUsername(value);
    },
}
const actions ={
    editAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            QuoteEdit(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
    deleteQuoteAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            QuoteDel(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
    addQuoteAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            QuoteAdd(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
        },
    uploadAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            UploadQuoteattachment(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
    deleteQuoteattachmentAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            QuoteattachmentDel(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
    editQuoteAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            QuoteRecordEdit(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
    copyQuoteAction(context, repuestData) {
        return new Promise((resolve, reject) => {
            QuoteCopy(repuestData).then((response) => {
                resolve(response);
            }).catch(error => {
                reject(error);
            })
        })
    },
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};